/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'

import {
    GET_EVENTLOGS,
    GET_LOGINLOGS,
    GET_TRANSACTIONLOGS,
    GET_IMPORTLOGS,
    DELETE_IMPORTLOG,
    GET_MENUS,
    GET_SUB_MENUS,
    GET_SUB_MENUS_BY_MENU_ID,
    GET_ROLE,
    GET_ROLES,
    CREATE_ROLE,
    UPDATE_ROLE,
    DELETE_ROLE,

    GET_CONTRACT_AGING_NINETY_DAY,
    GET_CONTRACT_NEXT_ROUND_NULL,
    GET_CONTRACT_TRANSACTION_NOT_UPDATE,
    GET_CONTRACT_NEXT_ROUND_FIRST_PRINCIPLE_PERIOD,
    GET_CONTRACT_REPEAT_PAYMENTS,
    GET_CONTRACT_TO_BE_FEE,

    DAILY_CALCULATORS,
    DAILY_CREATE_USER_STUDENT,
    MONTHLY_EIR_CALCULATORS,

    GET_MAINTENANCES,
    UPDATE_MAINTENANCES,

    GET_CONFIG,
    GET_CONFIG_SIGNER,
    UPDATE_CONFIG,
    UPDATE_CONFIG_SIGNER,
    SEND_OTP_EMAIL,
} from '@/queries/modules/system'

import {
    error,
    addItemSuccess,
    updateItemSuccess,
    deleteItemSuccess,
} from '@/utils/notification'

export async function initializing(context, payload) {
  context.commit('setInitializing', payload)
}

export async function getEventLogs(context, payload) {
    // console.log('Get EventLogs...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_EVENTLOGS,
                fetchPolicy: 'network-only'
            })

        const { data } = await response
        const { getEventLogs: eventLogs } = data

        context.commit('setEventLogs', eventLogs)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getLoginLogs(context, payload) {
    // console.log('Get LoginLogs...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_LOGINLOGS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        const {getLoginLogs} = data
       // console.log(getLoginLogs)
        context.commit('setLoginLogs', getLoginLogs)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getTransactionLogs(context, payload) {
    // console.log('Get TransacetionLogs...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_TRANSACTIONLOGS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setTransactionLogs', data.getTransactionLogs)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getImportLogs(context, payload) {
    // console.log('Get TransacetionLogs...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_IMPORTLOGS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response
        context.commit('setImportLogs', data.getImportLogs)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function deleteImportLog(context, payload) {
  // console.log('Delete Period...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const variables = {
          id: payload.form.id
      }
      // console.log(variables)
      const response = await apolloClient
          .mutate({
              mutation: DELETE_IMPORTLOG,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      context.commit('delImportLog', data.deleteImportLog)
      context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
      // console.log(e)
      context.commit('setError', error(null, null))
  }
}

export async function getMenus(context, payload) {
    // console.log('Get Menus...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_MENUS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setMenus', data.getMenus)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getSubMenusByMenuId(context, payload) {
    // console.log('Get Sub Menus...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {

        const variables = {id: payload.form.id}

        const response = await apolloClient
            .query({
                query: GET_SUB_MENUS_BY_MENU_ID,
                variables,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setSubMenus', data.getSubMenusByMenuID)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getSubMenus(context, payload) {
    // console.log('Get Sub Menus...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_SUB_MENUS,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setSubMenus', data.getSubMenus)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getRole(context, payload) {
    // console.log('Get Role...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const variables = {
            id: payload.form.id
        }
        const response = await apolloClient
            .query({
                query: GET_ROLE,
                variables,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setRole', data.getRole)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function getRoles(context, payload) {
    // console.log('Get Roles...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const response = await apolloClient
            .query({
                query: GET_ROLES,
                fetchPolicy: 'network-only'
            })

        const {data} = await response

        context.commit('setRoles', data.getRoles)
        context.commit('setSuccess', null)
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(e.toString(), null));
    }
}

export async function createRole(context, payload) {
    // console.log('Add Role...')

    context.commit('clearError')
    context.commit('setProcessing', true)

    const variables = {
        payload: payload.form
    }

    try {
        const response = await apolloClient
            .mutate({
                mutation: CREATE_ROLE,
                variables,
                fetchPolicy: 'no-cache'
            })

        const {data} = await response

        context.commit('setSuccess', addItemSuccess({}))

        if (payload.redirect != null) {
            setTimeout(() => {
                payload.vm.$router.push(payload.redirect)
            }, 200);
        }
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(null, null))
    }
}

export async function updateRole(context, payload) {
    // console.log('Crate Role...')

    context.commit('clearError')
    context.commit('setProcessing', true)

    const variables = {
        id: payload.id,
        payload: payload.form
    }

    try {
        const response = await apolloClient
            .mutate({
                mutation: UPDATE_ROLE,
                variables,
                fetchPolicy: 'no-cache'
            })

        const {data} = await response

        context.dispatch('getNavMenuItems', null, {root: true})
        context.dispatch('getPermissions', null, {root: true})
        context.commit('setSuccess', updateItemSuccess({}))
        if (payload.redirect != null) {
            setTimeout(() => {
                payload.vm.$router.push(payload.redirect)
            }, 200);
        }
    } catch (e) {
        // console.log(e);
        context.commit('setError', error(null, null))
    }
}

export async function deleteRole(context, payload) {
    // console.log('Delete Role...')

    context.commit('clearError')
    context.commit('setProcessing', true)
    try {
        const variables = {
            id: payload.form.id
        }

        const response = await apolloClient
            .mutate({
                mutation: DELETE_ROLE,
                variables,
                fetchPolicy: 'no-cache'
            })
        const {data} = await response

        context.commit('delRole', data.deleteRole)
        context.commit('setSuccess', deleteItemSuccess({}))

    } catch (e) {
        // console.log(e)
        context.commit('setError', error(null, null))
    }
}

export async function getContractAgingNinetyDay(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_AGING_NINETY_DAY,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractAgingNinetyDay
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractNextRoundNull(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_NEXT_ROUND_NULL,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractNextRoundNull
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractTransactionNotUpdate(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_TRANSACTION_NOT_UPDATE,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractTransactionNotUpdate
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractNextRoundFirstPrinciplePeriod(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_NEXT_ROUND_FIRST_PRINCIPLE_PERIOD,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractNextRoundFirstPrinciplePeriod
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractRepeatPayments(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_REPEAT_PAYMENTS,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractRepeatPayments
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getContractToBeFee(context, payload) {
  // console.log('Get EventLogs...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
      const response = await apolloClient
          .query({
              query: GET_CONTRACT_TO_BE_FEE,
              fetchPolicy: 'network-only'
          })

      const {data} = await response

      context.commit('setSuccess', null)
      return data.getContractToBeFee
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function dailyCalculators(context, payload) {
  // console.log('Daily Calculators...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .mutate({
              mutation: DAILY_CALCULATORS,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      context.commit('setSuccess', addItemSuccess({}))
      return data.dailyCalculators
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(null, null))
  }
}

export async function dailyCreateUserStudent(context, payload) {
  // console.log('Daily Calculators...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .mutate({
              mutation: DAILY_CREATE_USER_STUDENT,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      context.commit('setSuccess', addItemSuccess({}))
      return data.dailyCreateUserStudent
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(null, null))
  }
}

export async function monthlyEirCalculators(context, payload) {
  // console.log('Daily Calculators...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .mutate({
              mutation: MONTHLY_EIR_CALCULATORS,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      context.commit('setSuccess', addItemSuccess({}))
      return data.monthlyEirCalculators
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(null, null))
  }
}

export async function getMaintenances(context, payload) {
  // console.log('Get Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .query({
              query: GET_MAINTENANCES,
              fetchPolicy: 'network-only'
          })
      const {data} = await response
      // console.log(data)
      context.commit('setMaintenances', data.getMaintenances)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function updateMaintenances(context, payload) {
  // console.log('Create Contract...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
      payload: payload.form
  }
  try {
      const response = await apolloClient
          .mutate({
              mutation: UPDATE_MAINTENANCES,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      // console.log(data)
      context.commit('setMaintenances', data.updateMaintenances)
      context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(null, null))
  }
}

export async function getConfig(context, payload) {
  // console.log('Get Config...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .query({
              query: GET_CONFIG,
              fetchPolicy: 'network-only'
          })

      const {data} = await response
      const {config} = data

      context.commit('setConfig', config)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getConfigSigner(context, payload) {
  // console.log('Get Config Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  try {
      const response = await apolloClient
          .query({
              query: GET_CONFIG_SIGNER,
              fetchPolicy: 'network-only'
          })

      const {data} = await response
      const {configSigner} = data

      context.commit('setConfigSigner', configSigner)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(e.toString(), null));
  }
}

export async function updateConfig(context, payload) {
  // console.log('Update Config...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  // Ensure payload.notify defaults to true if it's null or undefined
  const notify = payload.notify !== false

  const variables = {
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_CONFIG,
        variables,
        fetchPolicy: 'no-cache'
      })

    const {data} = await response
    const {updateConfig: config} = data
    context.commit('setConfig', config)

    if(notify) {
      context.commit('setSuccess', updateItemSuccess({}))
    }
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(null, null))
  }
}

export async function updateConfigSigner(context, payload) {
  // console.log('Update Config Signer...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      payload: payload.form
  }

  try {
      const response = await apolloClient
          .mutate({
              mutation: UPDATE_CONFIG_SIGNER,
              variables,
              fetchPolicy: 'no-cache'
          })

      const {data} = await response
      const {updateConfigSigner: configSigner} = data
      context.commit('setConfigSigner', configSigner)
      context.commit('setSuccess', updateItemSuccess({}))
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(null, null))
  }
}

export async function sendOtpEmail(context, payload) {
  // console.log('Send OTP Email...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      otpType: payload.otpType,
      otpRef: payload.otpRef
  }

  try {
      const response = await apolloClient
          .mutate({
              mutation: SEND_OTP_EMAIL,
              variables,
              fetchPolicy: 'no-cache'
          })

    const {data} = await response
    const { sendOtpEmail } = data
    return sendOtpEmail;
  } catch (e) {
      // console.log(e);
      context.commit('setError', error(null, null))
  }
}
